import React, { Component, Fragment } from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch, withRouter } from 'react-router-dom';
import ErrorBoundary from '../../Misc/Error'
import NotificationSystem from 'react-notification-system';
import Dashboard from './Dashboard'
import CatererHeader from './CatererHeader'
import MenuMasterList from '../../SchoolAdmin/Caterer/MenuMaster/menuMasterList';
import MenuMaster from '../../SchoolAdmin/Caterer/MenuMaster/menuMaster';
import NewMenu from '../../SchoolAdmin/Caterer/NewMenu/newMenu';
import { _addNotification, _addNotificationError } from "../../../server/util";
import { MealTypes } from '../../../server/constants';
import FilterBar from './FilterBar';
import Orders from '../Orders';
import OrderDetails from '../Orders/orderDetails';
class CatererHome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectSchool: 0,
            mealType: MealTypes.LUNCH,
            schoolList: [],
            showSchoolDropdown:true
        }
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
        this.initSchools();
    }
    initSchools = () => {
        const schools = (JSON.parse(sessionStorage.getItem('loggedInUserDetails')) || {}).schools || [];
        //const sid=schools.length>0?schools[0].schoolId:0
        this.setState({
            schoolList: schools
            //,selectedSchool:sid
        });
    }
    showHideSchoolsDropdown=(status)=>{
        this.setState({showSchoolDropdown:status})
    }
    render() {
        return (<Fragment>
            <NotificationSystem ref="notificationSystem" />
            <Router>
                <div style={{overflowY:'scroll', overflowX:'hidden', height:'90vh'}}>
                    <CatererHeader />
                    <FilterBar showSchoolsDropdown={this.state.showSchoolDropdown}
                        selectSchool={this.state.selectSchool}
                        schoolList={this.state.schoolList}
                        showSchoolOpen={true}
                        onSchoolChange={(id) => {
                            this.setState({ selectSchool: id });
                        }}
                        onMenuTypeChange={(type) => {
                            this.setState({ mealType: type })
                        }}
                        mealType={this.state.mealType} />
                    <ErrorBoundary>
                        <Switch>
                            <Route exact path="/caterer/dashboard" render={() => <Dashboard {...this.state} />} />
                            <Route exact path='/caterer/orders' render={() => <Orders {...this.state} showHideSchoolsDropdown={this.showHideSchoolsDropdown} />}  />
                            <Route exact path='/caterer/orderDetails' render={() => <OrderDetails {...this.state} showHideSchoolsDropdown={this.showHideSchoolsDropdown} />} />
                            <Route exact path="/caterer/menuMasterList" component={MenuMasterList} />
                            <Route exact path='/caterer/menuMaster/:id?' component={MenuMaster} />
                            <Route exact path="/caterer/createMenu" component={NewMenu} />
                            <Route exact path="/caterer/" render={() => <Dashboard {...this.state}  />} />
                        </Switch>
                    </ErrorBoundary>
                </div>
            </Router>
        </Fragment>)
    }
}
export default CatererHome


// WEBPACK FOOTER //
// ./src/components/Caterer/Home/CatererHome.jsx